import React, { useEffect, useState } from "react";
import { IoCloseCircle } from "react-icons/io5";
import walletModel from "../../model/wallet.model";
import moment from "moment";
import back from "../../Asset/product/back.png";
import AOS from "aos";
import { FaRupeeSign } from "react-icons/fa";

const Wallethistory = ({ wallethistory, setWallethistory }) => {
  const [datalist, setDatalist] = useState();
  const[loading,setLoading]=useState(false);

  const GetData = async () => {
    setLoading(true)
    walletModel
      .get()
      .then((responce) => {
        setDatalist(responce?.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error",error)
      });
  };
  useEffect(() => {
    GetData();
  }, []);
  console.log("wallet", datalist);
    useEffect(() => {
        AOS.init();
      }, []);
  return (
    <div
      className="w-full  bg-black/50 fixed inset-0 z-50 flex justify-center items-center"
      onClick={() => {
        setWallethistory(false);
      }}
    >
      <div
        className="bg-Background1 pt-4 pl-6 pr-6 pb-6 w-1/2 max-h-4/5 rounded-2xl"
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={{
    backgroundImage: `url(${back})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  }}
  data-aos="flip-up"
      >
        <div className="flex justify-between mb-5">
          <span className="title text-lg text-textColor font-bold">
            Wallet History
          </span>
          <span className="text-3xl">
            <IoCloseCircle
              className="cursor-pointer"
              onClick={() => {
                setWallethistory(false);
              }}
            />
          </span>
        </div>
        <div className="px-4 py-2 bg-white rounded-xl">
          <div className="grid grid-cols-4 text-lg font-bold text-textColor bg-Background8 p-2 rounded-md">
            <div className="flex flex-col ">
              <span className="text-[14px]">Transation Id</span>
            </div>
            <div className="flex flex-col">
              <span className="text-[14px]">Date Time</span>
            </div>
            <div className="flex flex-col">
              <span className="text-[14px]">Amount </span>
            </div>
            <div className="flex flex-col">
              <span className="text-[14px]">Status</span>
            </div>
           
          </div>
          <div className="w-full h-4/5 overflow-auto mt-3 p-2 text-textColor font-semibold">
           
            {datalist?.map((item, index) => {
              console.log("transaction history",item)
              return (
                <div className="grid grid-cols-4 mt-1" key={index}>
                  <div className="flex flex-col text-[12px] title2">
                  <span> Trns-0123</span>
                  </div>
                  <div className="flex flex-col text-[12px] title2">
                    <span>{moment(item?.createdAt).format("DD MMM hh:mm A")}</span>
                  </div>
                  <div className="flex flex-col text-[12px] title2">
                    <span className="flex items-center gap-1">{item?.after_update && <FaRupeeSign />}{item?.after_update}</span>
                  </div>
                  <div className="flex flex-col text-[12px] title2">
                    <span>{item?.type}</span>
                  </div>
                  
                </div>
              );
            })}

          </div>
        </div>
      </div>
    </div>
  );
};

export default Wallethistory;
